import { render, staticRenderFns } from "./Debtor.vue?vue&type=template&id=3236914e&scoped=true&"
import script from "./Debtor.vue?vue&type=script&lang=ts&"
export * from "./Debtor.vue?vue&type=script&lang=ts&"
import style0 from "./Debtor.vue?vue&type=style&index=0&id=3236914e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3236914e",
  null
  
)

export default component.exports